import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyGuestsComponent } from './my-guests.component';
import { SharedModule } from '@app/shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatProgressSpinnerModule,
  MatTabsModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatSlideToggleModule
} from '@angular/material';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AddGuestComponent } from './add-guest/add-guest.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { Angular2CsvModule } from 'angular2-csv';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatPaginatorModule } from '@angular/material/paginator';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
@NgModule({
  declarations: [MyGuestsComponent, AddGuestComponent],
  imports: [
    CommonModule,
    SharedModule,
    NgxDatatableModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    NgSelectModule,
    MatProgressSpinnerModule,
    Angular2CsvModule,
    BrowserModule,
    MatPaginatorModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  entryComponents: [AddGuestComponent]
})
export class MyGuestsModule {}
